import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

import {
  AiRequestTracePageDto,
  AiRuntimeHealthDto,
  AiRuntimeProfileDto,
  AiStatisticsOverviewDto,
} from "../../../api/apiServices/ai/controllers/admin/admin.requestsDto";

export type AiMonitoringFilters = {
  range: [dayjs.Dayjs, dayjs.Dayjs];
};

const initialState: {
  loading: boolean;
  failed: boolean;
  filters: AiMonitoringFilters;
  data?: AiStatisticsOverviewDto;
  profile?: AiRuntimeProfileDto;
  health?: AiRuntimeHealthDto;
  traces?: AiRequestTracePageDto;
} = {
  loading: false,
  failed: false,
  filters: {
    range: [dayjs().subtract(30, "day"), dayjs()],
  },
};

const aiMonitoringSlice = createSlice({
  name: "aiMonitoring",
  initialState,
  reducers: {
    loadStatistics(state) {
      state.loading = true;
      state.failed = false;
    },
    loadStatisticsSuccess(
      state,
      action: PayloadAction<{
        data: AiStatisticsOverviewDto;
        profile: AiRuntimeProfileDto;
        health: AiRuntimeHealthDto;
        traces: AiRequestTracePageDto;
      }>,
    ) {
      state.loading = false;
      state.failed = false;
      state.data = action.payload.data;
      state.profile = action.payload.profile;
      state.health = action.payload.health;
      state.traces = action.payload.traces;
    },
    loadStatisticsReject(state) {
      state.loading = false;
      state.failed = true;
    },
    changeRange(state, action: PayloadAction<[dayjs.Dayjs, dayjs.Dayjs]>) {
      state.filters.range = action.payload;
      state.loading = true;
      state.failed = false;
    },
  },
});

export default aiMonitoringSlice;
